import type { SVGProps } from 'react'
import * as React from 'react'

const buttonIconRegisterInvoicePayment = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={48} height={48} rx={24} fill="#2ACC88" />
    <line x1={18.9463} y1={17.4614} x2={28.4848} y2={17.4614} stroke="white" strokeWidth={2} strokeLinecap="round" />
    <line x1={18.9463} y1={21.1538} x2={28.4848} y2={21.1538} stroke="white" strokeWidth={2} strokeLinecap="round" />
    <line x1={18.9463} y1={24.8462} x2={23.4078} y2={24.8462} stroke="white" strokeWidth={2} strokeLinecap="round" />
    <path
      d="M32.8076 25.3846V13.8462C32.8076 12.8266 31.9811 12 30.9615 12H16.6538C15.6342 12 14.8076 12.8266 14.8076 13.8462V32.7692C14.8076 33.7888 15.6342 34.6154 16.6538 34.6154H23.5768"
      stroke="white"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1={30.5771} y1={29.6135} x2={30.5771} y2={34.9981} stroke="white" strokeWidth={2} strokeLinecap="round" />
    <line x1={33.1924} y1={32.3828} x2={27.8078} y2={32.3828} stroke="white" strokeWidth={2} strokeLinecap="round" />
  </svg>
)

export default buttonIconRegisterInvoicePayment
